module.exports = __webpack_public_path__ + "img/94.7.Chla.a43f5d02.png";